
import Grid from "@material-ui/core/Grid";
import Bignumber from "../../../../components/Bignumbers/Bignumber";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";
import PersonIcon from "@mui/icons-material/Person";

export default function BignumbersLogs({ data, isMobile }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={isMobile}>
        <Bignumber
          label="LOGINS REALIZADOS"
          value={data?.QuantidadeUsuario || "-"}
          icon={ExitToAppIcon}
          logScreen={true}
        />
      </Grid>
      <Grid item xs={isMobile}>
        <Bignumber
          label="TELAS ACESSADAS"
          value={data?.QuantidadeAcesso || "-"}
          icon={DesktopWindowsOutlinedIcon}
          logScreen={true}
        />
      </Grid>
      <Grid item xs={isMobile}>
        <Bignumber
          label="USUÁRIOS ATIVOS"
          value={data?.QuantidadeUsuarioAtivo || "-"}
          icon={PersonIcon}
          logScreen={true}
        />
      </Grid>
    </Grid>
  );
}
